import { Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { TakePaymentFormData } from '../../../../helpers/TakePaymentSchema';
import useTakePaymentStore, { TakePaymentStore } from '../../../../hooks/useTakePaymentStore';

export default function CancelPaymentButton() {
  const { reset } = useFormContext<TakePaymentFormData>();
  const clean = useTakePaymentStore((state: TakePaymentStore) => state.clean);

  const handleModalCancel = () => {
    reset();
    clean();
  };
  return (
    <Button variant="outlined" size="large" onClick={handleModalCancel} sx={{ marginRight: '1em' }}>
      Cancel
    </Button>
  );
}
